"use client";

import { c as _c } from "react/compiler-runtime";
import { IconArrowUpRight, IconMeteor, IconX } from "@tabler/icons-react";
import Link from "next/link";
import { useState } from "react";
import { useAnnouncement } from "@/lib/stores/ui-store";
import { Button } from "@domainstack/ui/button";
import { Separator } from "@domainstack/ui/separator";
import { cn } from "@domainstack/ui/utils";

/** A little longer than the 300ms exit animation. */
const EXIT_FALLBACK_MS = 400;
export function AnnouncementPill() {
  const $ = _c(15);
  const {
    visible,
    dismiss
  } = useAnnouncement();
  const [isExiting, setIsExiting] = useState(false);
  let t0;
  if ($[0] !== dismiss) {
    t0 = e => {
      e.preventDefault();
      e.stopPropagation();
      dismiss();
      setIsExiting(true);
      setTimeout(() => setIsExiting(false), EXIT_FALLBACK_MS);
    };
    $[0] = dismiss;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleDismiss = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = e_0 => {
      if (e_0.target === e_0.currentTarget) {
        setIsExiting(false);
      }
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const finishExit = t1;
  if (!visible && !isExiting) {
    return null;
  }
  const t2 = isExiting ? "animate-out duration-300 fade-out-0 fill-mode-forwards zoom-out-95 motion-reduce:duration-150 motion-reduce:zoom-out-100" : "slide-in-from-top-2.5 animate-in duration-300 fade-in-0 zoom-in-95 motion-reduce:duration-150 motion-reduce:slide-in-from-top-0 motion-reduce:zoom-in-100";
  let t3;
  if ($[3] !== t2) {
    t3 = cn("absolute right-0 bottom-full left-0 z-10 mb-8 flex items-center justify-center ease-[cubic-bezier(0.22,1,0.36,1)]", t2);
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = isExiting ? finishExit : undefined;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IconMeteor className="size-3.5 text-accent-gold" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Link href="/dashboard" className="group inline-flex items-center gap-2 py-1.5 pr-2 pl-3">{t5}<div className="text-foreground/90"><span className="mr-1.5 font-medium text-accent-gold">New!</span><span>{"Track domains & get health alerts."}</span></div><IconArrowUpRight className="size-3.5 text-muted-foreground transition-transform group-hover:translate-x-[1px] group-hover:-translate-y-[1px]" /></Link>;
    t7 = <Separator orientation="vertical" className="data-[orientation=vertical]:h-4" />;
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <IconX className="size-3.5" />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== handleDismiss) {
    t9 = <div className="relative inline-flex items-center rounded-full border bg-muted/40 text-sm transition-colors hover:border-foreground/20 hover:bg-muted/80">{t6}{t7}<Button variant="ghost" size="icon-xs" onClick={handleDismiss} className="mx-1 rounded-full text-muted-foreground/50 hover:text-muted-foreground" aria-label="Dismiss announcement">{t8}</Button></div>;
    $[9] = handleDismiss;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t3 || $[12] !== t4 || $[13] !== t9) {
    t10 = <div className={t3} onAnimationEnd={t4}>{t9}</div>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  return t10;
}